import { InsuranceActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  insuranceTypesList: null,
  deleted_insuranceType: null,
  saved_insuranceType: null,
  insuranceTypeDetails: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case InsuranceActionTypes.get_insuranceTypesList.REQUEST:
    return {
      ...state,
      loading: true,
      insuranceTypesList: null,
    };
  case InsuranceActionTypes.get_insuranceTypesList.SUCCESS:
    return {
      ...state,
      loading: false,
      insuranceTypesList: payload,
    };
  case InsuranceActionTypes.post_insuranceType.REQUEST:
    return {
      ...state,
      loading: true,
      saved_insuranceType: null,
    };
  case InsuranceActionTypes.post_insuranceType.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_insuranceType: payload,
    };
  case InsuranceActionTypes.get_insuranceTypeDetails.REQUEST:
    return {
      ...state,
      loading: true,
      insuranceTypeDetails: null,
    };
  case InsuranceActionTypes.get_insuranceTypeDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      insuranceTypeDetails: payload,
    };
  case InsuranceActionTypes.delete_insuranceType.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_insuranceType: null,
    };
  case InsuranceActionTypes.delete_insuranceType.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_insuranceType: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/reducers/InsuranceReducer.js